
export const dateToUTCServerFormatString = (date) => {
    return `${date.getUTCFullYear()}-${date.getUTCMonth() < 9 ?
        `0${date.getUTCMonth()+1}` : date.getUTCMonth()+1}-${date.getUTCDate() < 10 
        ? `0${date.getUTCDate()}` : date.getUTCDate()}T00:00:00Z`
}